import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { User } from '../models/user';
import { BehaviorSubject } from 'rxjs';

const TOKEN_KEY = 'recall-token';
const ACCOUNT_KEY = 'recall-account';
const REDIRECT_URL_KEY = 'recall-redirect-url';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  private accountSubject = new BehaviorSubject<User | null>(null);
  account?: User;

  token?: string;
  private redirectUrl?: string;

  constructor(public http: HttpClient, private router: Router
  ) {
    // this.loadToken();
  }

  async initialize(): Promise<void> {
    await this.loadToken();
    this.loadRedirectUrl();
  }

  async loadToken() {
    // Altrimenti, controlliamo la query string
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const tokenFromQuery = urlParams.get('token');
  
    // Se troviamo un token nella query string, lo impostiamo
    if (tokenFromQuery) {
      this.setToken(tokenFromQuery);
    }

    const token = await localStorage.getItem(TOKEN_KEY);
    const account = await localStorage.getItem(ACCOUNT_KEY);

    if (token) {
      this.setToken(token);

      if (account) {
        this.account = JSON.parse(account);
        console.log('Account caricato da localStorage:', this.account);
        this.accountSubject.next(this.account ?? null); // Notifica che l'account è disponibile
      }

      await this.getUser().then(
        () => { },
        (error: any) => {
          // Pulizia silenziosa senza navigare a /login
          // Il router gestirà la navigazione tramite AuthGuard
          this.token = undefined;
          this.account = undefined;
          localStorage.removeItem(TOKEN_KEY);
          localStorage.removeItem(ACCOUNT_KEY);
        }
      );
    } else {
      console.log('Nessun token trovato.');
    }
  }

  private loadRedirectUrl() {
    const savedUrl = localStorage.getItem(REDIRECT_URL_KEY);
    if (savedUrl) {
      this.redirectUrl = savedUrl;
    }
  }

  public setRedirectUrl(url: string) {
    this.redirectUrl = url;
    localStorage.setItem(REDIRECT_URL_KEY, url);
    console.log('URL di redirect salvato:', url);
  }

  public getRedirectUrl(): string | undefined {
    return this.redirectUrl;
  }

  public clearRedirectUrl() {
    this.redirectUrl = undefined;
    localStorage.removeItem(REDIRECT_URL_KEY);
  }

  public handlePostLoginRedirect(router: Router) {
    // Controlla se c'è un URL di redirect salvato
    const redirectUrl = this.getRedirectUrl();
    if (redirectUrl) {
      console.log('Redirecting to saved URL:', redirectUrl);
      this.clearRedirectUrl(); // Pulisce l'URL salvato
      router.navigateByUrl(redirectUrl, { replaceUrl: true });
      return true;
    }
    return false;
  }

  getAccountObservable() {
    return this.accountSubject;
  }

  public logout() {
    localStorage.clear();

    this.token = undefined;
    this.account = undefined;
    this.redirectUrl = undefined;

    this.router.navigate(['/login']);
    // Add any additional cleanup logic here
    // this.push.setSubscription(false);
    // this.push.removeUserTags();
  }

  public isAuthenticated(): boolean {
    // get the token
    const token = this.getToken();
    // return a boolean reflecting
    // whether or not the token is expired
    //return tokenNotExpired(null,token);

    return !!token;
  }

  public setToken(token:string) {
    console.log('imposto token');
    this.token = token;
    localStorage.setItem(TOKEN_KEY, token);
    console.log('token impostato');
      // localStorage.setItem('token',token);
  }

  public getToken(): string | null | undefined {
    return this.token;
  }

  public login(data: any){
    console.log(data);
    return new Promise((resolve, reject) => {

      const http_data = new URLSearchParams();
      http_data.set('username', data.username);
      http_data.set('password', data.password);

      this.http.post(environment.api_url + '/auth/token?short=true', http_data.toString(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
      }).subscribe(
      (res: any) => {
        if (res && res.access_token) {
          // auth standard - return token
          const response: any = res;

          console.log(response);
          this.setToken(response.access_token);

          resolve('Credenziali Corrette!');
        } else {
          // unhandled case
          console.log(res);
          reject('Si è verificato un errore nel login');
        }
      },
      err => {
        console.log(err);
        reject(err.error);
      }
      );
    });
  }

  public loginGoogle(data: any){
    console.log(data);
    return new Promise((resolve, reject) => {

      const http_data = new URLSearchParams();
      http_data.set('username', data.username);
      http_data.set('password', data.password);

      this.http.post(environment.api_url + '/auth/token?short=true', http_data.toString(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
      }).subscribe(
      (res: any) => {
        if (res && res.access_token) {
          // auth standard - return token
          const response: any = res;

          console.log(response);
          this.setToken(response.access_token);

          resolve('Credenziali Corrette!');
        } else {
          // unhandled case
          console.log(res);
          reject('Si è verificato un errore nel login');
        }
      },
      err => {
        console.log(err);
        reject(err.error);
      }
      );
    });
  }


  public preRegistration(data: any, referealCode: string, inviteId?: string){
    console.log(data);
    return new Promise((resolve, reject) => {
      let url = '';

      if(inviteId == null) {
        url = environment.api_url + '/user/register-referral/' + referealCode + '?email=' + data.email
      }
      else {
        url = environment.api_url + '/user/register-referral/' + referealCode + '?email=' + data.email + '&invitation_code=' + inviteId
      }

      this.http.post(url, {}).subscribe(
        (res: any) => {
          const response: any = res;

          console.log(response);

          resolve('Pre registrazione avvenuta con successo!');
        },
        err => {
          console.log(err);
          reject(err);
        }
      );
    });
  }


  getUser() {
    return new Promise((resolve, reject) => {
      this.http.get(environment.api_url + '/user/me').subscribe(
        (res: any) => {
          console.log('Utente ottenuto dal server:', res);

          if (res) {
            this.setUser(res);
            resolve('Utente ottenuto!');
          } else {
            reject('Errore nell\'ottenere l\'utente');
          }
        },
        (err) => {
          console.error('Errore nella richiesta getUser:', err);
          // switch(err.status) {            
          //   case 404:
          //     // this.utils.openSnackBar('Codice non valido', 'error'); 
          //     break;
          //   case 401:
          //   default:
          //     console.log('Token non valido, sloggando...');
          //     this.logout(); // Rimuove il token e l'account
          //     break;
          // }
          reject(err.error);
        }
      );
    });
  }

  verifyEmail(verifyToken: string) {
    return new Promise((resolve, reject) => {
      this.http.get(environment.api_url + '/user/verify-email?token='+verifyToken).subscribe(
        (res: any) => {
          console.log('Utente ottenuto dal server:', res);

          // if (res) {
          //   this.setUser(res);
          //   resolve('Utente ottenuto!');
          // } else {
          //   reject('Errore nell\'ottenere l\'utente');
          // }
        },
        (err) => {
          console.error('Errore nella richiesta getUser:', err);

          this.router.navigate(['/error'], { queryParams: { message: 'errors.emailVerificationError' } });

          reject(err.error);
        }
      );
    });
  }

  public setUser(account: User) {
    console.log('imposto account');
    this.account = new User(account);
    localStorage.setItem(ACCOUNT_KEY, JSON.stringify(account));
    this.accountSubject.next(this.account); // Notifica che l'account è stato aggiornato
    console.log('account impostato');
      // localStorage.setItem('token',token);
  }

  public editUser(data: any) {
    console.log('Modifica utente:', data);
    const body = {
      name: data.name,
      surname: data.surname,
      username: data.username,
      email: data.email,
      phone_number: data.phoneNumber,
      // birth_date: data.birthDate,
      gender: data.gender,
      // fiscal_code: data.cf,
    };

    return new Promise((resolve, reject) => {
      this.http.patch(environment.api_url + '/user/update', body).subscribe(
        (res: any) => {
          console.log('Risposta del server:', res);
          if (res) {
            this.setUser(res); // Aggiorna l'utente locale con i dati restituiti dal server
            resolve('Profilo aggiornato con successo!');
          } else {
            reject('Errore durante l\'aggiornamento del profilo');
          }
        },
        (err) => {
          console.error('Errore nella richiesta PATCH:', err);
          reject(err.error);
        }
      );
    });
  }

  public resetPassword(data: any){
    console.log(data);
    return new Promise((resolve, reject) => {
      let body = {
        token: data.token,
        password: data.newPassword,
      };

      this.http.post(environment.api_url + '/auth/reset-password', body).subscribe(
      (res: any) => {
        if(res) {
          console.log(res);
        }
        // if (res && res.access_token) {
        //   // auth standard - return token
        //   const response: any = res;

        //   console.log(response);
        //   this.setToken(response.access_token);

          resolve('Credenziali Corrette!');
        // } else {
        //   // unhandled case
        //   console.log(res);
        //   reject('Si è verificato un errore nel login');
        // }
      },
      err => {
        console.log(err);
        reject(err.error);
      }
      );
    });
  }

  public changePassword(data: any){
    console.log(data);
    return new Promise((resolve, reject) => {
      let body = {
        token: data.token,
        password: data.newPassword,
      };

      this.http.post(environment.api_url + '/auth/reset-password', body).subscribe(
      (res: any) => {
        if(res) {
          console.log(res);
        }
        // if (res && res.access_token) {
        //   // auth standard - return token
        //   const response: any = res;

        //   console.log(response);
        //   this.setToken(response.access_token);

          resolve('Credenziali Corrette!');
        // } else {
        //   // unhandled case
        //   console.log(res);
        //   reject('Si è verificato un errore nel login');
        // }
      },
      err => {
        console.log(err);
        reject(err.error);
      }
      );
    });
  }

  public isSubscribed(): boolean {
    return (this.account?.subscription?.type?.tier ?? 0) > 0;
  }

  public isLoggedIn(): boolean {
    return !!this.account && !!this.token;
  }
}
